import { d as dayjs } from "../../../dayjs.min-BUYAusmZ.js";
const formatDate = (date, format = "Do MMM YY") => dayjs(date).format(format);
export {
  formatDate
};
//# sourceMappingURL=formatDate.js.map
